export default __webpack_public_path__ + "static/media/nj.9da5f200.png";